/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityBatchTrxInfo = {
    BTNO: string;
    BTSTAT: HumanityBatchTrxInfo.BTSTAT;
    CMTRX: string;
    CFTRX: string;
};

export namespace HumanityBatchTrxInfo {

    export enum BTSTAT {
        PROCESSED_ON_L2 = 'PROCESSED_ON_L2',
        POSTED_ON_L1 = 'POSTED_ON_L1',
        CONFIRMED_ON_L1 = 'CONFIRMED_ON_L1',
    }


}

